import { forwardRef, memo, useMemo } from 'react'
import Input from './Input'

const BASE_INPUT_CLASS = [
  'h-[60px]', 'w-auto', 'min-w-0', 'rounded-[999px]', 'border-none', 'bg-transparent',
  'p-0', 'text-center', 'text-[46px]', 'font-[590]', 'leading-[48px]',
  'tracking-[-0.02em]', 'text-white', 'caret-[var(--figma-accent)]',
  'placeholder:text-white/30', 'selection:bg-[var(--figma-accent)]',
  'selection:text-white', 'outline-none', 'focus:outline-none',
  'focus-visible:!outline-none', 'focus:ring-0', '[appearance:textfield]',
  '[&::-webkit-outer-spin-button]:appearance-none',
  '[&::-webkit-inner-spin-button]:appearance-none',
].join(' ')

const BASE_SUFFIX_CLASS = 'shrink-0 text-[46px] font-[590] leading-[48px] tracking-[-0.02em] text-white/68'

const AmountInput = forwardRef(function AmountInput({
  value = '',
  onChange,
  suffix,
  suffixClassName = BASE_SUFFIX_CLASS,
  minWidth = 64,
  maxWidth = 160,
  digitWidth = 28,
  widthPadding = 8,
  inputClassName = '',
  wrapperClassName = '',
  ...props
}, ref) {
  const inputWidth = useMemo(() => {
    const digits = String(value || '0').replace(/\D/g, '').length
    return Math.min(maxWidth, Math.max(minWidth, digits * digitWidth + widthPadding))
  }, [digitWidth, maxWidth, minWidth, value, widthPadding])

  return (
    <div className={`flex items-center justify-center gap-1 ${wrapperClassName}`}>
      <Input
        ref={ref}
        value={value}
        onChange={onChange}
        variant="unstyled"
        style={{ width: inputWidth }}
        className={`${BASE_INPUT_CLASS} ${inputClassName}`}
        {...props}
      />
      {suffix ? (
        <span className={suffixClassName} aria-hidden="true">
          {suffix}
        </span>
      ) : null}
    </div>
  )
})

AmountInput.displayName = 'AmountInput'

export default memo(AmountInput)
